import { CheckBoxProps } from "../../interfaces/checkbox.interface";
import "./checkbox.scss";
const Checkbox = ({ label, id, ...props }: CheckBoxProps) => {
  return (
    <div className="form-group m-2">
      <input type="checkbox" id={id} {...props} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default Checkbox;
